import React from 'react';

class Alert extends React.Component{

    static defaultProps = {
        context: "info",
        title: "Alert",
        message: "A notification alert occured."
    };
    
    render(){
        const { context, title, message } = this.props;
        return (
            <div className={'text-white alert-dismissible fade show alert alert-'+context+ ' bg-' + context} role="alert">
              <button type="button" className="close font-weight-light" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <span className="font-weight-bold">{title}</span> {message}
            </div>
        );
    }
}

export default Alert;
